export default __webpack_public_path__ + "static/media/menu-caret.010d5478.svg";